
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dsarwebform",
      function () {
        return require("private-next-pages/dsarwebform.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dsarwebform"])
      });
    }
  